<template>

    <button :class="[size, 'button imitation']" @click.stop="impersonate()">

        <span class="icon is-small"><i class="icon-ak-industry-view"></i></span>
        <span>
            {{ siteId != null ? 'Apotheke' : manufacturerId != null
                ? 'Industriepartner'
                : ''
            }}
            imitieren
        </span>

    </button>

</template>


<script>

export default {

    props: {
        siteId: {
            type: Number,
            default: null
        },
        size: {
            type: String,
            default: 'is-normal'
        },
        manufacturerId: {
            type: Number,
            default: null
        },
    },

    methods: {

        impersonate() {

            /*
            var query = this.siteId == null
                ? 'user?filters[manufacturer]='+this.manufacturerId+'&fields=username'
                : 'user?filters[site]='+this.siteId;
              */

            var query = this.siteId == null
                ? 'user?filters[manufacturer]='+this.manufacturerId+'&fields=username&include=user.site,user.userRole,user.person'
                : 'user?filters[site]='+this.siteId+'&include=user.site,user.userRole,user.person';

            // fetch corrseponding username first
            this.axios.get(this.$config.api + query)
                .then((res) => {

                    var msg;

                    // show warning if no corresponding user was found
                    if(res.data.user.length == 0) {

                        if(this.siteId != null) {
                            msg = "MSG-WARNING-IMPERSONATING_PHARMACY_NOT_POSSIBLE";
                        }
                        else if(this.manufacturerId != null) {
                            msg = "MSG-WARNING-IMPERSONATING_INDUSTRY_NOT_POSSIBLE";
                        }
                        else {
                            msg = "MSG-WARNING-IMPERSONATING_NOT_POSSIBLE";
                        }

                        this.$notify.open({content: this.$t(msg), type: 'warning'});

                        return;

                    }

                    let user = res.data.user[0];

                      this.axios.get(`${this.$config.api}user/impersonate?username=${user.username}`)
                        .then((response) => {

                            /*
                            let userFull = {
                              ...user,
                              permissions: response.data.user.permissions
                            }
                            */

                            let userFull = response.data.user;

                            // "manufacturer"
                            if(this.manufacturerId != null) {


                                this.$store.dispatch('fetchCatalogPagesManufacturer', this.manufacturerId).then(() => {

                                    this.$store.commit("userLogIn", userFull);
                                    this.$store.commit("isImpersonating", true);
                                    this.$store.commit("setRedirectURL", this.$route.fullPath);

                                    localStorage.setItem('user', JSON.stringify(userFull));
                                    localStorage.setItem('isImpersonating', JSON.stringify(true));

                                    // redirect
                                    this.$router.push(user.defaultRoute).then((res) => {

                                      // make sure that the site is re-rendered
                                      this.$forceUpdate();

                                      // notify
                                      this.$notify.success({content: this.$t('MSG-SUCCESS-NOW_IMPERSONATING_USER') + ': ' + response.data.user.username });

                                    })

                                });

                           }

                            // "apotheke"
                            else if(this.siteId != null) {

                                // this.$store.commit("userLogIn", response.data.user);
                                this.$store.commit("userLogIn", userFull);
                                this.$store.commit("isImpersonating", true);
                                this.$store.commit("setRedirectURL", this.$route.fullPath);

                                // localStorage.setItem('user', JSON.stringify(response.data.user));
                                localStorage.setItem('user', JSON.stringify(userFull));
                                localStorage.setItem('isImpersonating', JSON.stringify(true));

                                // redirect
                                this.$router.push('/').then((res) => {

                                  // make sure that the site is re-rendered
                                  this.$forceUpdate();

                                  // notify
                                  this.$notify.success({content: this.$t('MSG-SUCCESS-NOW_IMPERSONATING_USER') + ': ' + user.username });

                                })

                            }

                        });

                });

        }

    }
}

</script>


<style scoped>


    .imitation {
        /*
        font-size: 12px;
        padding-top: 8px;
        padding-bottom: 8px;
        height: auto;
        */
    }
    .imitation.is-small {
        height: auto;
    }
    /*
    .imitation .icon {
        font-size: 12px !important;
        margin: 0 4px 0 0;
        height: inherit;
        line-height: inherit;
    }
    */
</style>
